var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.loading } }, [
    _c("div", { staticClass: "row scroll" }, [
      _c("div", { staticClass: "col-12", staticStyle: { margin: "0 auto" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "vs-list",
                [
                  _vm.auctionsStates[_vm.auction.estado]
                    ? _c("vs-list-item", {
                        attrs: {
                          icon: "info",
                          title: _vm.auctionsStates[_vm.auction.estado].label,
                          subtitle: "Estado Subasta"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "vs-list",
                [
                  _vm.auction.estado === _vm.auctionsStateCode.publicada
                    ? _c("vs-list-item", {
                        attrs: {
                          icon: "event",
                          title: _vm._f("dateFormat")(
                            _vm.auction.fechaPublicacion
                          ),
                          subtitle: "Fecha de Publicación"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "vs-list",
                [
                  _c("vs-list-item", {
                    attrs: {
                      icon: "event",
                      title: _vm._f("dateFormat")(_vm.auction.fechaCreacion),
                      subtitle: "Fecha de Creación"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "b-form",
                { attrs: { "data-vv-scope": "auction-form" } },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "mb-3", attrs: { label: "Fecha subasta" } },
                    [
                      _c("date-picker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          name: "date",
                          format: "DD MMM YYYY",
                          "value-type": "YYYY-MM-DD",
                          type: "date",
                          "data-vv-as": "fecha de subasta",
                          placeholder: "Fecha de subasta",
                          "data-cy": "auction-date-planner",
                          disabled: _vm.onlyReadInfo
                        },
                        model: {
                          value: _vm.auctionPlanner.fechaSubasta,
                          callback: function($$v) {
                            _vm.$set(_vm.auctionPlanner, "fechaSubasta", $$v)
                          },
                          expression: "auctionPlanner.fechaSubasta"
                        }
                      }),
                      _vm.errors.has("auction-form.date")
                        ? _c("div", [
                            _c("small", { staticClass: "text-danger" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.errors.first("auction-form.date")
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-3",
                      attrs: { label: "Aduana coordinadora" }
                    },
                    [
                      _c(
                        "v-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            disabled: _vm.onlyReadInfo,
                            options: _vm.customsCompanies,
                            reduce: function(company) {
                              return company.id
                            },
                            name: "managingCustoms",
                            state: _vm.errors.has(
                              "auction-form.managingCustoms"
                            )
                              ? false
                              : null,
                            "data-vv-as": "aduana coordinadora",
                            danger: _vm.errors.has(
                              "auction-form.managingCustoms"
                            ),
                            "danger-text": _vm.errors.first(
                              "auction-form.managingCustoms"
                            )
                          },
                          model: {
                            value: _vm.auctionPlanner.gestoraId,
                            callback: function($$v) {
                              _vm.$set(_vm.auctionPlanner, "gestoraId", $$v)
                            },
                            expression: "auctionPlanner.gestoraId"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              attrs: { slot: "no-options" },
                              slot: "no-options"
                            },
                            [_vm._v(" No hay coincidencias ")]
                          )
                        ]
                      ),
                      _vm.errors.first("auction-form.managingCustoms")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger\n               vs-input--text-validation-span v-enter-to",
                              staticStyle: { height: "32px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " El campo aduana coordinadora es obligatorio "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              !_vm.onlyReadInfo
                ? _c(
                    "div",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "badge-glow ml-3 mb-5",
                          attrs: {
                            "data-cy": "save",
                            variant: "primary",
                            size: "sm"
                          },
                          on: {
                            click: function($event) {
                              return _vm.attemptUpdateAuction()
                            }
                          }
                        },
                        [_vm._v(" Guardar cambios ")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-12 mt-5" },
        [
          _c("h5", { staticClass: "text-primary" }, [
            _vm._v(" Lotes de la Subasta ")
          ]),
          !_vm.selectedAuctionBatches.documentos.length
            ? _c("div", [
                _c("span", { staticClass: "lead collapse-title" }, [
                  _vm._v(" Subasta no cuenta con lotes asociados ")
                ])
              ])
            : _vm._e(),
          _vm.selectedBatches.length > 1
            ? _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "has-permission",
                      rawName: "v-has-permission",
                      value: "ED195",
                      expression: "'ED195'"
                    }
                  ],
                  attrs: {
                    size: "sm",
                    variant: "outline-danger",
                    "data-cy": "cancel-batch"
                  },
                  on: { click: _vm.showAlertDeleteActionBatch }
                },
                [
                  _c("feather-icon", { attrs: { icon: "TrashIcon" } }),
                  _vm._v(" Quitar lotes seleccionados de subasta ")
                ],
                1
              )
            : _vm._e(),
          _vm.selectedAuctionBatches.documentos.length
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "row bg-white shadow py-5 px-3 mb-4" },
                    [
                      _c("div", { staticClass: "col-11" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-2 text-center" }, [
                            _c("b", [_vm._v("#")])
                          ]),
                          _c("div", { staticClass: "col-5" }, [
                            _c("b", [_vm._v("Descripción")])
                          ]),
                          _c("div", { staticClass: "col-5" }, [
                            _c("b", [_vm._v("Información")])
                          ])
                        ])
                      ]),
                      _c("div", { staticClass: "col-1 text-center" }, [
                        _c("b", [_vm._v("...")])
                      ])
                    ]
                  ),
                  _vm._l(_vm.selectedAuctionBatches.documentos, function(
                    batch
                  ) {
                    return _c("AuctionDetailRow", {
                      key: batch.loteId,
                      attrs: {
                        batch: batch,
                        "only-read": _vm.onlyReadInfo,
                        "data-cy": "auction-detail-row"
                      },
                      on: {
                        "select-check-batch": _vm.selectCheckBatch,
                        "unselect-check-batch": _vm.unSelectCheckBatch,
                        "handle-delete-auction-batch": _vm.deleteAuctionBatch
                      }
                    })
                  })
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _vm.canAddBatch
                ? _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED178",
                          expression: "'ED178'"
                        }
                      ],
                      staticClass: "badge-glow ml-3 mt-5",
                      attrs: {
                        variant: "secondary",
                        "data-cy": "edit-auction-status",
                        size: "sm"
                      },
                      on: {
                        click: function($event) {
                          return _vm.openBatchForm()
                        }
                      }
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "list" }
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v("Agregar lotes")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canPlanifyAuction
                ? _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED196",
                          expression: "'ED196'"
                        }
                      ],
                      staticClass: "badge-glow ml-3 mt-5",
                      attrs: {
                        variant: "primary",
                        "data-cy": "edit-auction-status",
                        size: "sm"
                      },
                      on: {
                        click: function($event) {
                          return _vm.updateAuction(
                            _vm.auctionsActionStates.PLANIFICAR
                          )
                        }
                      }
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "list" }
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v("Comenzar a planificar")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.auction.estado === _vm.auctionsStateCode.planificada &&
              !_vm.onlyReadInfo
                ? _c(
                    "b-button",
                    {
                      staticClass: "badge-glow ml-3 mt-5",
                      attrs: {
                        variant: "primary",
                        "data-cy": "auction-replan-button",
                        size: "sm"
                      },
                      on: {
                        click: function($event) {
                          return _vm.auctionReplan(_vm.auction)
                        }
                      }
                    },
                    [_vm._v(" Re-Planificar ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }